module.exports = __webpack_public_path__ + "img/zhth-4.10262037.png";